<template>
  <v-layout
    flex-wrap:
    wrap
  >
    <!-- article -->
    <v-flex xs12>
      <v-card>
        <v-card-title class="pb-4 d-flex justify-space-between">
          <h2 class="pt-4 primary--text">Simulazione di Vendita</h2>
          <v-btn
            color="primary"
            @click="reset"
          >Reset</v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-layout row>
            <v-flex
              xs12
              md2
              pa-3
            >
              <v-select
                :items="articoli"
                label="Articolo"
                v-model="article.articolo"
                @change="calcolo('ricarico')"
                fill
              ></v-select>
            </v-flex>
            <v-flex
              xs12
              md2
              pa-3
            >
              <v-text-field
                fill
                label="Pagato"
                append-icon="mdi-currency-eur"
                v-model="article.pagato"
                @change="calcolo"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md2
              pa-3
            >
              <v-text-field
                fill
                :disabled="article.articolo != '17'"
                label="Ricarico"
                append-icon="mdi-percent"
                v-model="article.ricarico"
                @change="calcolo('pap')"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md2
              pa-3
            >
              <v-text-field
                fill
                label="Prezzo al Pubblico"
                append-icon="mdi-currency-eur"
                v-model="article.pap"
                @change="calcolo('ricarico')"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md2
              pa-3
            >
              <v-text-field
                fill
                label="Incassato"
                append-icon="mdi-currency-eur"
                v-model="article.incassato"
                @change="calcolo('incassato')"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              md2
              pa-3
            >
              <v-text-field
                fill
                label="Numero rate"
                append-icon="mdi-counter"
                v-model="article.rate"
                @change="calcolo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left font-weight-bold">Iva</th>
                      <th class="text-left font-weight-bold">Utile</th>
                      <th class="text-left font-weight-bold">Singola rata</th>
                      <th class="text-left font-weight-bold">Fisso Dilapay</th>
                      <th class="text-left font-weight-bold">Variabile Dilapay (2.4%)</th>
                      <th class="text-left font-weight-bold">Costo Dilapay</th>
                      <th class="text-left font-weight-bold">Incidenza Dilapay</th>
                      <th class="text-left font-weight-bold">Utile Finale</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="red--text">{{article.iva != '' ? `${article.iva}€` : '-'}}</td>
                      <td :class="utileClassColor">{{article.utile != '' ? `${article.utile}€` : '-'}}</td>
                      <td>{{article.rata != '' ? `${article.rata}€` : '-'}}</td>
                      <td>{{article.dilapay.fisso != '' ? `${article.dilapay.fisso}€` : '-'}}</td>
                      <td>{{article.dilapay.variabile != '' ? `${article.dilapay.variabile}€` : '-'}}</td>
                      <td class="red--text">{{article.costoRate != '' ? `${article.costoRate}€` : '-'}}</td>
                      <td :class="incidenzaClassColor">{{article.incidenza != '' ? `${article.incidenza}%` : '-'}}</td>
                      <td :class="utileFinaleClassColor">{{article.utileFinale != '' ? `${article.utileFinale}€` : '-'}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>

  </v-layout>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'Calcolatori',
    props: {
      kind: { type: String, default: '' },
      article: {
        type: Object,
        default: () => {
          return {
            id: '',
            articolo: '17',
            pagato: '',
            ricarico: '',
            pap: '',
            iva: '',
            utile: '',
            incassato: '',
            rate: '',
            utileFinale: '',
            costoRate: '',
            rata: '',
            incidenza: '',
            dilapay: {
              fisso: '',
              variabile: ''
            }
          }
        }
      },
    },
    data() {
      return {
        articoli: [
          '17',
          '17***',
          '36'
        ],
        repairCost: 0.00,
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },
    methods: {
      calcolo(mode) {

        if (this.article.pagato) {

          this.article.pagato = parseFloat(this.article.pagato)

          if (mode == 'pap') {
            if (this.article.articolo == '36') {
              this.calcoloPapConIvaAlMArgine()
              this.calcoloUtileConIvaAlMargine()
              this.calcoloIvaAlMargine()
            } else if (this.article.articolo == '17') {
              this.calcoloPap()
              this.calcoloIva()
              this.calcoloUtile()
            }
          } else if (mode == 'ricarico') {
            if (this.article.articolo == '36') {
              this.calcoloUtileConIvaAlMargine()
              this.calcoloRicaricoConIvaAlMArgine()
              this.calcoloIvaAlMargine()
            } else if (this.article.articolo == '17') {
              this.calcoloRicarico()
              this.calcoloIva()
              this.calcoloUtile()
            }
          } else if (mode == 'incassato') {
            if (this.article.articolo == '17***') {
              this.calcoloIva()
              this.calcoloUtileConIncassato()
              this.calcoloRicarico17bis()
            }
          }

          if (this.article.rate != '') {
            this.calcoloRateizzazione()
          } else {
            this.resetRateizzazione()
          }
        }

      },
      reset() {
        this.article.id = ''
        this.article.pagato = ''
        this.article.ricarico = ''
        this.article.pap = ''
        this.article.iva = ''
        this.article.utile = ''
        this.article.utileFinale = ''
        this.article.rate = ''
        this.article.costoRate = ''
        this.article.rata = ''
        this.article.incidenza = ''
        this.article.dilapay.fisso = ''
        this.article.dilapay.variabile = ''
      },
      calcoloPap() {
        this.article.pap = ((parseFloat(this.article.pagato) + (parseFloat(this.article.pagato) * parseFloat(this.article.ricarico) / 100)) * 1.22).toFixed(2)
      },
      calcoloPapConIvaAlMArgine() {
        this.article.pap = ((parseFloat(this.article.pagato) + parseFloat(this.article.utile)) / parseFloat(this.article.pagato) * 100 - 100).toFixed(2)
      },
      calcoloRicarico() {
        this.article.ricarico = ((parseFloat(this.article.pap) / 1.22) / parseFloat(this.article.pagato) * 100 - 100).toFixed(2)
      },
      calcoloRicaricoConIvaAlMArgine() {
        this.article.ricarico = ((parseFloat(this.article.pagato) + parseFloat(this.article.utile)) / parseFloat(this.article.pagato) * 100 - 100).toFixed(2)
      },
      calcoloRicarico17bis() {
        this.article.ricarico = (parseFloat(this.article.utile) / parseFloat(this.article.pagato) * 100).toFixed(2)
      },
      calcoloIva() {
        this.article.iva = (parseFloat(this.article.pap) - (parseFloat(this.article.pap) / 1.22)).toFixed(2)
      },
      calcoloIvaAlMargine() {
        this.article.iva = ((parseFloat(this.article.pap) - parseFloat(this.article.pagato)) - (parseFloat(this.article.pap) - parseFloat(this.article.pagato)) / 1.22).toFixed(2)
      },
      calcoloUtile() {
        this.article.utile = (parseFloat(this.article.pap) - parseFloat(this.article.iva) - parseFloat(this.article.pagato)).toFixed(2)
      },
      async calcoloUtileConIvaAlMargine() {
        this.article.utile = ((parseFloat(this.article.pap) - parseFloat(this.article.pagato) - parseFloat(await this.fetchRepairCost(this.article.id))) / 1.22).toFixed(2)
      },
      calcoloUtileConIncassato() {
        this.article.utile = (parseFloat(this.article.incassato) - parseFloat(this.article.pagato) - parseFloat(this.article.iva)).toFixed(2)
      },
      calcoloRateizzazione() {
        this.article.rate = parseInt(this.article.rate)

        let prezzo

        if (this.article.incassato != '') {
          prezzo = parseFloat(this.article.pap) - parseFloat(this.article.incassato)
        } else {
          prezzo = parseFloat(this.article.pap)
        }

        this.article.rata = (parseFloat(prezzo) / parseInt(this.article.rate)).toFixed(2)
        this.article.dilapay.fisso = (parseInt(this.article.rate) * 0.60).toFixed(2)
        this.article.dilapay.variabile = (parseFloat(prezzo) * 2.9 / 100).toFixed(2)
        this.article.costoRate = (parseFloat(this.article.dilapay.fisso) + parseFloat(this.article.dilapay.variabile)).toFixed(2)
        this.article.utileFinale = (parseFloat(this.article.utile) - parseFloat(this.article.costoRate)).toFixed(2)
        this.article.incidenza = (100 - (parseFloat(this.article.utileFinale) * 100 / parseFloat(this.article.utile))).toFixed(2)

      },
      calcoloRateizzazioneConIvaAlMargine() {
        this.article.rate = parseInt(this.article.rate)

        let prezzo

        if (this.article.incassato != '') {
          prezzo = parseFloat(this.article.pap) - parseFloat(this.article.incassato)
        } else {
          prezzo = parseFloat(this.article.pap)
        }

        this.article.rata = (parseFloat(prezzo) / parseInt(this.article.rate)).toFixed(2)
        this.article.dilapay.fisso = (parseInt(this.article.rate) * 0.60).toFixed(2)
        this.article.dilapay.variabile = (parseFloat(prezzo) * 2.9 / 100).toFixed(2)
        this.article.costoRate = (parseFloat(this.article.dilapay.fisso) + parseFloat(this.article.dilapay.variabile)).toFixed(2)
        this.article.utileFinale = (parseFloat(this.article.utile) - parseFloat(this.article.costoRate)).toFixed(2)
        this.article.incidenza = (100 - (parseFloat(this.article.utileFinale) * 100 / parseFloat(this.article.utile))).toFixed(2)

      },
      resetRateizzazione() {
        this.article.rata = ''
        this.article.dilapay.fisso = ''
        this.article.dilapay.variabile = ''
        this.article.costoRate = ''
        this.article.utileFinale = ''
        this.article.incidenza = ''

      },
      async fetchRepairCost(id) {

        let cost = 0.00

        if (this.kind == 'smartphone') {
          const { data } = await axios.post(
            `${process.env.VUE_APP_API}/smartphones/fetch-repairs-and-accessories`, { id }, this.config
          )

          data.data.replacements.map(el => {
            cost = parseFloat(cost) + parseFloat(el.cost)
          })

          data.data.accessories.map(el => {
            cost = parseFloat(cost) + parseFloat(el.cost)
          })

        }
        console.log(cost)
        return cost
      }
    },
    computed: {
      utileClassColor() {
        if (this.article.utile) {
          return parseFloat(this.article.utile) >= 0 ? 'green--text' : 'red--text'
        }
      },
      utileFinaleClassColor() {
        if (this.article.utileFinale) {
          return parseFloat(this.article.utileFinale) >= 0 ? 'green--text' : 'red--text'
        }
      },
      incidenzaClassColor() {
        const incidenza = this.article.incidenza

        if (this.article.incidenza) {
          switch (true) {
            case (incidenza >= 100):
              return 'red--text'
              break
            case (incidenza >= 75 && incidenza < 100):
              return 'orange--text'
              break
            case (incidenza >= 50 && incidenza < 75):
              return 'yellow--text'
              break
            case (incidenza >= 25 && incidenza < 50):
              return 'blue--text'
              break
            case (incidenza >= 0 && incidenza < 25):
              return 'green--text'
              break
            default:
              return ''
              break
          }
        }
      },
    },
    watch: {
      article: {
        async handler(val) {
          this.calcolo('ricarico')
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  th {
    font-weight: bold;
    font-size: 16px !important;
  }

  td {
    font-weight: bold;
    font-size: 18px !important;
  }
</style>